<template>
  <section class="section">
    <h4 class="title has-text-centered is-4">Salaries</h4>

    <earnings-list :earnings="salaries.data" :loading="loadingSalaries"></earnings-list>

    <b-pagination
      class="mt-4"
      v-model="salaries.current_page"
      :total="salaries.total"
      :per-page="salaries.per_page"
      range-before="3"
      range-after="3"
      order="is-centered"
      icon-pack="fas"
      @change="handlePageChange"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page">
    </b-pagination>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import EarningsList from '../../components/Transactions/EarningsList.vue';

export default {
  name: 'Salaries',
  components: { EarningsList },
  computed: {
    ...mapState('patreon', ['loadingSalaries', 'salaries']),
  },
  mounted() {
    this.loadSalaries();
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.query': function () {
      this.loadSalaries();
    },
  },
  methods: {
    loadSalaries() {
      this.$store.dispatch('patreon/loadSalaries', this.$route.query);
    },
    handlePageChange(pageNum) {
      const params = {
        ...this.$route.query,
        page: pageNum,
      };
      const queryString = Object.keys(params).map((key) => `${key}=${params[key] || ''}`).join('&');

      this.$router.push({ path: `/patreon/salaries?${queryString}` });
    },
  },
};
</script>

<style>
.user-table {
  font-size: 12px;
}
.clickable-user {
  cursor: pointer;
  text-decoration: underline;
}
</style>
